import { getSelectedEnvironments } from '@gonfalon/openapi/operations/getSelectedEnvironments';

import { createQueryOptions } from '../internal/createQueryOptions';

export const selectedEnvironments = createQueryOptions(getSelectedEnvironments);
